import { extension } from "_constants";
import { Source } from "interfaces";
import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { useEffect } from "react";
import { downloadSourceFile } from "services";
import { useAppSelector } from "store/store";
import {
  downloadFile,
  formatBytes,
  getFileIconByFileType,
  getUserRole,
} from "utils";

export const FileDetailRow = ({ source }: { source?: Source }) => {
  const currentSource = useAppSelector(
    (state) => state.gestioneSourcesSlice.currentSource
  );

  const startDownloadFile = () => {
    if ((source ?? currentSource)?.id) {
      downloadSourceFile((source ?? currentSource)!.id)
        .then((response) => {
          downloadFile(
            response,
            0,
            `${(source ?? currentSource)!.fileName}.${
              (source ?? currentSource)!.fileType
            }`
          );
        })
        .catch((_) => {});
    }
  };

  useEffect(() => {}, [currentSource]);

  return (
    <div className="width-100 padd-top-18 padd-bottom-18">
      <div className="width-100 source-detail flex-container justify-between">
        {(source ?? currentSource) && (
          <div className="flex-container align-center source-detail-inner">
            <Tooltip target={`.file-name`} mouseTrack mouseTrackLeft={10} />
            <img
              src={getFileIconByFileType((source ?? currentSource)!.fileType)}
              alt={extension}
              className="file-icon"
            />
            <span
              className="file-detail-name ellipsis file-name"
              data-pr-tooltip={(source ?? currentSource)!.fileName}
            >
              {(source ?? currentSource)!.fileName}
            </span>
            <span className="file-detail-size min-width-fit-content">{`• ${formatBytes(
              (source ?? currentSource)!.size ?? 0,
              2
            )}`}</span>
          </div>
        )}
        {(getUserRole() !== "USER" ||
          (getUserRole() === "USER" && source?.type === "PRIVATE")) && (
          <Button
            icon={PrimeIcons.DOWNLOAD}
            onClick={startDownloadFile}
            text
            severity="secondary"
          />
        )}
      </div>
    </div>
  );
};
